/**
 *
 * @export
 * @interface AuthorizedUser
 */
export interface AuthorizedUser {
  /**
   *
   * @type {string}
   * @memberof AuthorizedUser
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof AuthorizedUser
   */
  phone?: string;
  /**
   *
   * @type {string}
   * @memberof AuthorizedUser
   */
  idNumber?: string;
  /**
   *
   * @type {string}
   * @memberof AuthorizedUser
   */
  idType?: string;
  /**
   *
   * @type {Date}
   * @memberof AuthorizedUser
   */
  createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof AuthorizedUser
   */
  updatedAt?: Date;
  /**
   *
   * @type {number}
   * @memberof AuthorizedUser
   */
  courierUserId?: number;
  /**
   *
   * @type {number}
   * @memberof AuthorizedUser
   */
  id?: number;
  // /**
  //  *
  //  * @type {number}
  //  * @memberof DeliveryRequest
  //  */
}

/**
 * Check if a given object implements the AuthorizedUser interface.
 */
export function instanceOfAuthorizedUser(
  value: object
): value is AuthorizedUser {
  return true;
}

export function AuthorizedUserFromJSON(json: any): AuthorizedUser {
  return AuthorizedUserFromJSONTyped(json, false);
}

export function AuthorizedUserFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AuthorizedUser {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
    phone: json['phone'] == null ? undefined : json['phone'],
    idNumber: json['idNumber'] == null ? undefined : json['idNumber'],
    idType: json['idType'] == null ? undefined : json['idType'],
    createdAt:
      json['createdAt'] == null ? undefined : new Date(json['createdAt']),
    updatedAt:
      json['updatedAt'] == null ? undefined : new Date(json['updatedAt']),
    courierUserId:
      json['courierUserId'] == null ? undefined : json['courierUserId'],
    id: json['id'] == null ? undefined : json['id'],
    // courierUserAssigneeId:
    //   json['courierUserAssigneeId'] == null
    //     ? undefined
    //     : json['courierUserAssigneeId'],
  };
}

export function AuthorizedUserToJSON(json: any): AuthorizedUser {
  return AuthorizedUserToJSONTyped(json, false);
}

export function AuthorizedUserToJSONTyped(
  value?: AuthorizedUser | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value['name'],
    phone: value['phone'],
    idNumber: value['idNumber'],
    idType: value['idType'],
    courierUserId: value['courierUserId'],
    id: value['id'],
    // courierUserAssigneeId: value['courierUserAssigneeId'],
  };
}
